/* src/app/components/master-detail-user-profile/notification-preferences-detail.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=notification-preferences-detail.component.css.map */
